import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  Stack,
  Text,
} from '@chakra-ui/react';
import { Button } from '@components/forms';
import { useMutation } from '@apollo/client';
import { DELETE_MEASURE } from '@queries/V2moms';
import { useV2momContext } from '@contexts/V2momProvider';
import { useNotifier } from '@utils/Notify';


const DeleteMeasureModal = ({modalDisclosure, measure}) => {
  const { serverError } = useNotifier();
  const { dispatch } = useV2momContext();

  const [deleteMethod, { loading }] = useMutation(DELETE_MEASURE,{
    onCompleted: (data) => {
      dispatch({ type: 'DELETE_MEASURE', payload: { measure: data.deleteMeasure.measure } })
      modalDisclosure.onClose();
    },
    onError: (error) => {
      serverError(error.message)
    },
  });
  
  const handleDelete = () => {
    deleteMethod({ variables: {
      id: measure.id,
    }});
  }

  if (loading) return <p>Loading ...</p>;

  return (
    <Modal isOpen={modalDisclosure.isOpen} onClose={modalDisclosure.onClose} size='lg' motionPreset='slideInBottom' isCentered>
      <ModalOverlay />
      <ModalContent borderRadius='sm'>
        <ModalHeader>
          Delete measure
        </ModalHeader>
        <ModalBody>
          Are you sure you want to delete <Text as='span' fontWeight='bold' color='red.600'>{measure.name}</Text>? Deleting this measure will also delete all updates associated with it.
          <Text pt={4} fontWeight='bold'>This action cannot be undone.</Text>
          <Stack direction='row' spacing={2} my={4} justifyContent='right'>
            <Button variant='ghost' onClick={modalDisclosure.onClose}>Close</Button>
            <Button variant='dangerOutline' onClick={handleDelete}>Delete</Button>
          </Stack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}

export default DeleteMeasureModal;